import { render, staticRenderFns } from "./extras-info.vue?vue&type=template&id=38e5241e"
import script from "./extras-info.vue?vue&type=script&lang=js"
export * from "./extras-info.vue?vue&type=script&lang=js"
import style0 from "./extras-info.vue?vue&type=style&index=0&id=38e5241e&prod&lang=postcss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports